/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { KeyRound, Store, ShieldCheck, Loader2, AlertTriangle, Wrench } from 'lucide-react';
import { toast } from 'sonner';
import { api, setToken, setCurrentUser } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { PinPad } from '@/components/portal/PinPad';
import { homeFor } from '@/lib/base';

export default function Invite() {
  const { token } = useParams();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');
  const [first, setFirst] = useState('');
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);

  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(e?.response?.data?.detail || 'Invitation invalide'));
  }, [token]);

  const fail = (msg) => { setShake(true); setTimeout(() => setShake(false), 500); setFirst(''); toast.error(msg); };
  const onPin = async (pin) => {
    if (!first) { setFirst(pin); return; }
    if (pin !== first) { fail('Les deux codes ne correspondent pas, recommencez'); return; }
    setLoading(true);
    try {
      const r = await api.post(`/auth/invite/${token}/set-pin`, { pin });
      setToken(r.data.token); setCurrentUser(r.data.user);
      toast.success(`Bienvenue ${r.data.user.name} — votre PIN est enregistré`);
      nav(homeFor(r.data.user), { replace: true });
    } catch (e) { fail(e?.response?.data?.detail || 'Erreur'); } finally { setLoading(false); }
  };

  return <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-6">
    <Card className="card-flat p-8 sm:p-10 max-w-sm w-full" data-testid="invite-card">
      {error ? <div className="text-center" data-testid="invite-error"><AlertTriangle className="h-8 w-8 mx-auto text-amber-500 mb-3" /><h1 className="font-display text-xl font-bold">Lien invalide</h1><p className="text-sm text-zinc-500 mt-2">{error}</p></div>
        : !info ? <div className="flex justify-center py-10 text-zinc-400"><Loader2 className="h-5 w-5 animate-spin" /></div>
        : <>
          <div className="flex flex-col items-center mb-6 text-center">
            <div className="w-12 h-12 bg-zinc-950 rounded-md flex items-center justify-center mb-4"><KeyRound className="h-5 w-5 text-white" /></div>
            <h1 className="font-display text-2xl font-bold tracking-tight">Bonjour {info.name}</h1>
            <p className="text-sm text-zinc-500 mt-1" data-testid="invite-step">{first ? 'Confirmez votre code PIN' : 'Choisissez votre code PIN à 6 chiffres'}</p>
            <div className="mt-3 flex flex-wrap justify-center gap-1.5" data-testid="invite-stores">{[...info.stores, ...(info.modules || [])].map((s) => <span key={s} className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full bg-zinc-100 text-zinc-700">{info.role === 'collaborator' ? <Wrench className="h-3 w-3" /> : <Store className="h-3 w-3" />}{s}</span>)}</div>
          </div>
          <PinPad onComplete={onPin} loading={loading} shake={shake} testId="invite-pin" />
          <p className="text-[10px] text-zinc-400 text-center mt-6 flex items-center justify-center gap-1"><ShieldCheck className="h-3 w-3" /> Ce code vous servira à chaque connexion. Gardez-le secret.</p>
        </>}
    </Card>
  </div>;
}
